<template>
  <confirmation-dialog :action="cancel" confirm-text="Выйти без сохранения" cancel-text="Продолжить редактирование">
    <template #activator>
      <e-btn variant="secondary" class="mr-4">Отмена</e-btn>
    </template>
    <div class="h3">Выход из режима редактирования</div>
    <div class="text-secondary mt-8">Вся введенная информация будет утрачена без возможности восстановления.</div>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { EBtn } from '@/core/components/ui';
import { useTariffsStore } from '@/parts/tariffs/store/tariffs';

const { cancelEditPlacingVariants } = useTariffsStore();

const emit = defineEmits<{
  (event: 'cancel'): void;
}>();

const cancel = async () => {
  await cancelEditPlacingVariants();

  emit('cancel');
};
</script>

<style scoped lang="scss"></style>
